import React from 'react';

const SvgFolder = (props) => (
  <svg width={24} height={24} {...props}>
    <defs>
      <path
        id="folder_svg__a"
        d="M16.83 12.482l-6.755 6.824v.972h.97l6.704-6.846-.92-.95zm.934-.944l.922.938.912-.932-.927-.922-.907.916zm5.314-7.916H.665A.672.672 0 0 1 0 2.944c0-.374.298-.677.665-.677h22.413c.368 0 .666.303.666.677a.672.672 0 0 1-.666.678zm0 4.006H.665A.672.672 0 0 1 0 6.95c0-.374.298-.678.665-.678h22.413c.368 0 .666.304.666.678a.672.672 0 0 1-.666.678zM10.331 11.66H.665A.672.672 0 0 1 0 10.983c0-.374.298-.677.665-.677h9.666c.367 0 .665.303.665.677a.672.672 0 0 1-.665.678zm-1.315 4.022H.666a.663.663 0 0 1-.577-.339.689.689 0 0 1 0-.677.663.663 0 0 1 .576-.34h8.351c.368 0 .666.304.666.679a.672.672 0 0 1-.666.677zm-2.961 4.023H.665A.672.672 0 0 1 0 19.028c0-.375.298-.678.665-.678h5.39c.367 0 .665.303.665.678a.672.672 0 0 1-.665.678zm5.263 1.927H9.41a.659.659 0 0 1-.481-.192.684.684 0 0 1-.2-.485v-1.934a.684.684 0 0 1 .196-.483l9.272-9.356a.657.657 0 0 1 .933 0l1.882 1.867a.684.684 0 0 1 0 .967l-9.224 9.427a.659.659 0 0 1-.469.19z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="folder_svg__b" fill="#fff">
        <use xlinkHref="#folder_svg__a" />
      </mask>
      <use fill="currentColor" xlinkHref="#folder_svg__a" />
      <g fill="currentColor" mask="url(#folder_svg__b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);

export default SvgFolder;
